import { ref } from 'vue'

function useResize(
  initial: number,
  min: number,
  max: number,
  getDelta: (startPos: number, ev: MouseEvent, rect: DOMRect) => number,
  getStartPos: (e: MouseEvent) => number,
) {
  const pct = ref(initial)
  const containerEl = ref<HTMLElement>()
  const isDragging = ref(false)

  function startDrag(e: MouseEvent) {
    e.preventDefault()
    isDragging.value = true
    document.body.classList.add('resizing')
    if (!containerEl.value) return
    const rect = containerEl.value.getBoundingClientRect()
    const startPos = getStartPos(e)
    const startPct = pct.value
    const onMove = (ev: MouseEvent) => {
      if (!containerEl.value) return
      pct.value = Math.min(max, Math.max(min, startPct + getDelta(startPos, ev, rect)))
    }
    const onUp = () => {
      isDragging.value = false
      document.body.classList.remove('resizing')
      document.removeEventListener('mousemove', onMove)
      document.removeEventListener('mouseup', onUp)
    }
    document.addEventListener('mousemove', onMove)
    document.addEventListener('mouseup', onUp)
  }

  return { pct, containerEl, isDragging, startDrag }
}

export function useHorizResize(initial = 33, min = 20, max = 75) {
  return useResize(
    initial,
    min,
    max,
    (startX, ev, rect) => ((ev.clientX - startX) / rect.width) * 100,
    (e) => e.clientX,
  )
}

export function useVertResize(initial = 50, min = 15, max = 75) {
  return useResize(
    initial,
    min,
    max,
    (startY, ev, rect) => ((startY - ev.clientY) / rect.height) * 100,
    (e) => e.clientY,
  )
}
